export const URL_SYNC_PAGE_PARAM = 'page';
export const URL_SYNC_SEARCH_PARAM = 'search';
export const URL_SYNC_ORDER_PARAM = 'order';
export const URL_SYNC_ORDER_BY_PARAM = 'orderBy';
export const URL_SYNC_HIDE_COLS_PARAM = 'hideCols';
export const URL_SYNC_CONTEXT_PARAM = 'context';
export const URL_SYNC_DATE_FROM_PARAM = 'dateFrom';
export const URL_SYNC_DATE_TO_PARAM = 'dateTo';

/** Param names the grid owns; a filter may not claim one of these. */
export const URL_SYNC_RESERVED_PARAMS = [
	URL_SYNC_PAGE_PARAM,
	URL_SYNC_SEARCH_PARAM,
	URL_SYNC_ORDER_PARAM,
	URL_SYNC_ORDER_BY_PARAM,
	URL_SYNC_HIDE_COLS_PARAM,
	URL_SYNC_CONTEXT_PARAM,
	URL_SYNC_DATE_FROM_PARAM,
	URL_SYNC_DATE_TO_PARAM,
] as const;

/** Calendar dates in the query string (`YYYY-MM-DD`). Datetimes are truncated to the date part. */
export const URL_SYNC_CALENDAR_DATE = /^\d{4}-\d{2}-\d{2}$/;

export const URL_SYNC_MIN_PAGE = 1;
